<template>
  <nav v-if="totalPages > 1" class="blog-pagination" aria-label="Pagination">
    <router-link
      v-if="page > 1"
      :to="pageLink(page - 1)"
      class="blog-pagination__btn"
      rel="prev">
      Previous
    </router-link>
    <span class="blog-pagination__info">Page {{ page }} of {{ totalPages }}</span>
    <router-link
      v-if="page < totalPages"
      :to="pageLink(page + 1)"
      class="blog-pagination__btn"
      rel="next">
      Next
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'BlogPagination',
  props: {
    page: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    basePath: { type: String, required: true },
  },
  methods: {
    pageLink(p) {
      if (p <= 1) return this.basePath
      const sep = this.basePath.includes('?') ? '&' : '?'
      return `${this.basePath}${sep}page=${p}`
    },
  },
}
</script>
